import { render, staticRenderFns } from "./EmployeeSecurityPage.vue?vue&type=template&id=25840dc1&scoped=true&lang=pug&"
import script from "./EmployeeSecurityPage.vue?vue&type=script&lang=ts&"
export * from "./EmployeeSecurityPage.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeSecurityPage.vue?vue&type=style&index=0&id=25840dc1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25840dc1",
  null
  
)

export default component.exports